


































































































import { defineComponent, onMounted, ref } from "@nuxtjs/composition-api";
import { checkHttpLink, changeImage } from "~/helpers";
import { getUrlPathByCategoryId } from "~/modules/catalog/category/helpers";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination, Scrollbar]);

export default defineComponent({
  name: "CircleCategory",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    Swiper,
    SwiperSlide,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const { activeCategory } = useTraverseCategory();

    const slickOption = {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 6,
      centeredSlides: false,
      loop: false,
      pagination: false,
      navigation: true,
      slidesPerColumn: 2,
      slidesPerColumnFill: "row",
      scrollbar: { draggable: true },
      freeMode: true,

      breakpoints: {
        640: {
          slidesPerView: 3,
          slidesPerGroup: 3,

          slidesPerColumn: 2,
          slidesPerColumnFill: "row",
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,

          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
        1024: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 4,

          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
        1400: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 4,

          slidesPerColumn: 1,
          slidesPerColumnFill: "row",
        },
      },
    };

    const categoryLinks = ref<Record<number, string>>({});

    onMounted(async () => {
      const categoryIds = props.item.data.map((item) => item.category);
      const results = categoryIds.map((id: number) => {
        const url_path = getUrlPathByCategoryId(id, activeCategory.value);
        return {
          id,
          url: `/${url_path}`,
        };
      });

      // Gán dữ liệu vào categoryLinks
      categoryLinks.value = Object.fromEntries(
        results.map(({ id, url }) => [id, url])
      );
    });

    return {
      checkHttpLink,
      changeImage,
      slickOption,
      categoryLinks,
      modules: [Navigation, Scrollbar],
    };
  },
});
